module.exports = __webpack_public_path__ + "assets/4c7a18fd35ade00e509d2f018c36f8e2.mp3";